var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10020_124528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "#353C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.488 14.5V12.708L5.92 9.3H7.392L7.776 10.388C7.84 10.5853 7.904 10.7773 7.968 10.964C8.032 11.1507 8.09867 11.3453 8.168 11.548H8.2C8.26933 11.3453 8.336 11.1507 8.4 10.964C8.46933 10.7773 8.53867 10.5853 8.608 10.388L8.992 9.3H10.432L8.864 12.708V14.5H7.488ZM9.89325 15.78L11.3013 8.82H12.1813L10.7733 15.78H9.89325ZM12.7791 14.5V9.3H14.1871L15.3391 11.62L15.8351 12.788H15.8671C15.8351 12.5053 15.7978 12.1853 15.7551 11.828C15.7125 11.4653 15.6911 11.124 15.6911 10.804V9.3H17.0031V14.5H15.5951L14.4431 12.172L13.9471 11.012H13.9151C13.9471 11.3053 13.9845 11.6307 14.0271 11.988C14.0698 12.34 14.0911 12.676 14.0911 12.996V14.5H12.7791Z",
    fill: "#353C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10020_124528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYn);
export default __webpack_public_path__ + "static/media/yn.166abc83ce6d226838d64f674374ff3b.svg";
export { ForwardRef as ReactComponent };